import api from './api';

export interface OutwardImportRowResult {
  rowIndex: number;
  status: 'success' | 'failed';
  dispatchNumber?: string;
  reason?: string;
}

export interface OutwardImportSummary {
  totalRows: number;
  succeeded: number;
  failed: number;
  results: OutwardImportRowResult[];
}

export const outwardImportService = {
  importExcel: async (file: File): Promise<OutwardImportSummary> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/outward-import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    });

    const responseData = response as any;
    return responseData.data as OutwardImportSummary;
  },
};
